var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRouteFour(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2092_58)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 12.8584C19 10.089 17.1339 7.66932 14.5025 6.94018C14.3371 3.0853 11.1498 0 7.25488 0C3.25446 0 0 3.25446 0 7.25488C0 8.55864 0.347031 9.82804 1.00601 10.9425L0.0266724 14.4829L3.56728 13.5038C4.59171 14.1095 5.74731 14.4508 6.94003 14.5022C7.66903 17.1338 10.0888 19 12.8584 19C13.9639 19 15.0389 18.7056 15.9834 18.1462L18.9732 18.9732L18.1462 15.9834C18.7056 15.0389 19 13.9639 19 12.8584ZM3.74297 12.3L1.62339 12.8864L2.20975 10.7668L2.0761 10.5578C1.44625 9.57233 1.11328 8.43021 1.11328 7.25488C1.11328 3.86836 3.86836 1.11328 7.25488 1.11328C10.6414 1.11328 13.3965 3.86836 13.3965 7.25488C13.3965 10.6414 10.6414 13.3965 7.25488 13.3965C6.07956 13.3965 4.93758 13.0635 3.952 12.4337L3.74297 12.3ZM17.3766 17.3766L15.8038 16.9414L15.5938 17.0781C14.7795 17.6071 13.8335 17.8867 12.8584 17.8867C10.6817 17.8867 8.76897 16.4793 8.09129 14.4612C11.4245 14.0769 14.0769 11.4245 14.4613 8.09115C16.4793 8.76897 17.8867 10.6817 17.8867 12.8584C17.8867 13.8335 17.6071 14.7795 17.0781 15.5938L16.9414 15.8038L17.3766 17.3766Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.69824 10.0566H7.81152V11.1699H6.69824V10.0566Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.36816 5.56641C8.36816 5.88256 8.23944 6.17436 8.00577 6.38818L6.69824 7.58495V8.94336H7.81152V8.0752L8.75738 7.20951C9.21748 6.78841 9.48145 6.18958 9.48145 5.56641C9.48145 4.33861 8.48268 3.33984 7.25488 3.33984C6.02708 3.33984 5.02832 4.33861 5.02832 5.56641H6.1416C6.1416 4.95251 6.64098 4.45312 7.25488 4.45312C7.86878 4.45312 8.36816 4.95251 8.36816 5.56641Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2092_58"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRouteFour);
export default __webpack_public_path__ + "static/media/route-four.e8a6eea9984b518ee2a15cac5a211913.svg";
export { ForwardRef as ReactComponent };